import { render, staticRenderFns } from "./ContainerPage.vue?vue&type=template&id=621528bb&"
import script from "./ContainerPage.vue?vue&type=script&lang=ts&"
export * from "./ContainerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports